'use strict';

define('messages', ['bootbox', 'translator', 'storage'], function (bootbox, translator, storage) {
	const messages = {};

	messages.show = function () {
		showCookieWarning();
	};

	function showCookieWarning() {
		if (!config.cookies.enabled || !navigator.cookieEnabled || app.inAdmin || storage.getItem('cookieconsent') === '1') {
			return;
		}

		config.cookies.message = translator.unescape(config.cookies.message);
		config.cookies.dismiss = translator.unescape(config.cookies.dismiss);
		config.cookies.link = translator.unescape(config.cookies.link);
		config.cookies.link_url = translator.unescape(config.cookies.link_url);

		app.parseAndTranslate('partials/cookie-consent', config.cookies, function (html) {
			$(document.body).append(html);
			$(document.body).addClass('cookie-consent-open');

			const warningEl = $('.cookie-consent');
			const dismissEl = warningEl.find('button');
			dismissEl.on('click', function () {
				// Save consent cookie and remove warning element
				storage.setItem('cookieconsent', '1');
				warningEl.remove();
				$(document.body).removeClass('cookie-consent-open');
			});
		});
	}

	messages.showInvalidSession = function () {
		bootbox.alert({
			title: '[[error:invalid-session]]',
			message: '[[error:invalid-session-text]]',
			closeButton: false,
			callback: function () {
				window.location.reload();
			},
		});
	};

	messages.showSessionMismatch = function () {
		bootbox.alert({
			title: '[[error:session-mismatch]]',
			message: '[[error:session-mismatch-text]]',
			closeButton: false,
			callback: function () {
				window.location.reload();
			},
		});
	};

	return messages;
});
